export default __webpack_public_path__ + "static/media/693.23fdbb04.png";